module.exports = __webpack_public_path__ + "img/starCoins@2x.94716023.png";